import script from "./DefaultInputForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultInputForm.vue?vue&type=script&setup=true&lang=js"

import "./DefaultInputForm.vue?vue&type=style&index=0&id=5964e681&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5964e681"]])

export default __exports__